(function () {
  'use strict';

  /* ==========================================================================
     NEON DEMO — van aangeleverd logo naar neon
     ========================================================================== */

  var stage = document.getElementById('neon-b2b-stage');
  var toggle = document.getElementById('neon-b2b-toggle');
  var stageLabel = document.getElementById('neon-b2b-stage-label');

  function setNeon(on) {
    if (!stage) return;
    stage.classList.toggle('is-on', on);
    if (toggle) {
      toggle.setAttribute('aria-pressed', on ? 'true' : 'false');
      var txt = toggle.querySelector('span');
      if (txt) txt.textContent = on ? 'Toon origineel' : 'Zet het aan';
    }
    if (stageLabel) {
      stageLabel.textContent = on
        ? (stage.dataset.labelAfter || 'Eindresultaat')
        : (stage.dataset.labelBefore || 'Aangeleverd logo');
    }
  }

  if (toggle) {
    toggle.addEventListener('click', function () {
      setNeon(!stage.classList.contains('is-on'));
    });
  }

  if (stage && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    setTimeout(function () { setNeon(true); }, 1400);
  }

  /* ==========================================================================
     STICKY MOBIELE CTA — zichtbaar zodra het formulier uit beeld is
     ========================================================================== */

  var sticky = document.getElementById('neon-b2b-sticky');
  var formCard = document.getElementById('neon-b2b-card');

  if (sticky && formCard && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (entries) {
      sticky.classList.toggle('is-visible', !entries[0].isIntersecting);
    }, { threshold: 0 }).observe(formCard);
  }

  /* ==========================================================================
     MULTISTEP FORMULIER
     Stap 1: keuze + upload/tekst → Stap 2: contact (lead binnen) →
     Stap 3: bedankt + kwalificatievragen (progressive profiling)
     ========================================================================== */

  var formRoot = document.getElementById('neon-b2b-form');
  if (!formRoot) return;

  var PARTIAL_API = 'https://offerte.bonfireclub.eu/api/leads/partial';
  var SUBMIT_API = 'https://offerte.bonfireclub.eu/api/leads/submit';
  var UPLOAD_URL_API = 'https://offerte.bonfireclub.eu/api/leads/upload-url';
  var STORAGE_KEY = 'bf_partial_lead_id';
  var BRON = 'neon-b2b-landing';
  // Relatief pad: werkt op elk domein waar de shop op draait. Instelbaar in de
  // theme editor als er toch een absolute URL nodig is.
  var THANKYOU_URL = formRoot.dataset.thankyouUrl || '/pages/thank-you';

  var ALLOWED_EXT = /\.(jpg|jpeg|png|gif|svg|pdf|ai|eps)$/i;
  var MAX_FILE_SIZE = 50 * 1024 * 1024;

  var state = {
    neonType: '',        // 'Logo' | 'Tekst'
    logoLater: false,
    tekstOnbekend: false,
    selectedFile: null,
    uploadedFileUrl: '',
    uploadPromise: null,   // loopt terwijl de klant stap 2 invult
    uploadFailed: false,
    partialLeadId: sessionStorage.getItem(STORAGE_KEY) || '',
    submitted: false
  };

  var steps = Array.prototype.slice.call(formRoot.querySelectorAll('.neon-b2b-form__step'));
  // De stappenbalk staat in de kaart-header, buiten formRoot
  var bars = Array.prototype.slice.call(document.querySelectorAll('#neon-b2b-card .neon-b2b-form__steps i'));

  function go(n) {
    steps.forEach(function (s) { s.classList.toggle('on', s.dataset.step === String(n)); });
    bars.forEach(function (b, i) { b.classList.toggle('on', i < n); });
    if (n > 1 && formCard) formCard.scrollIntoView({ block: 'start', behavior: 'smooth' });
  }

  /* ---------- attributie (gezet door snippets/neon-attribution.liquid) ---------- */

  var ATTRIBUTION_KEYS = [
    'utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content',
    'gclid', 'fbclid', 'ttclid', 'msclkid', 'landing_page', 'referrer'
  ];

  function getAttribution() {
    try {
      var raw = localStorage.getItem('bf_attribution');
      return raw ? (JSON.parse(raw) || {}) : {};
    } catch (e) { return {}; }
  }

  /* ---------- helpers ---------- */

  function val(id) {
    var el = document.getElementById(id);
    return el ? el.value.trim() : '';
  }

  // Eén naamveld in de UI; de API/CAPI verwacht voornaam (fn) en achternaam (ln)
  function splitNaam() {
    var full = val('neon-b2b-naam').replace(/\s+/g, ' ');
    if (!full) return { voornaam: '', achternaam: '' };
    var parts = full.split(' ');
    return { voornaam: parts[0], achternaam: parts.slice(1).join(' ') };
  }

  function showError(id, msg) {
    var el = document.getElementById(id);
    if (!el) return;
    if (msg) el.textContent = msg;
    el.classList.add('is-visible');
  }

  function hideErrors() {
    formRoot.querySelectorAll('.neon-b2b-form__error').forEach(function (el) {
      el.classList.remove('is-visible');
    });
  }

  /* ---------- form start micro-conversie ---------- */

  var formStartFired = false;
  function fireFormStart() {
    if (formStartFired) return;
    formStartFired = true;
    if (typeof fbq === 'function') fbq('trackCustom', 'FormStart', { content_name: 'Neon B2B Aanvraag' });
    if (typeof gtag === 'function') gtag('event', 'form_start', { form_id: 'neon-b2b-form', form_name: 'Neon B2B Aanvraag' });
  }
  formRoot.addEventListener('input', fireFormStart);
  formRoot.addEventListener('click', fireFormStart, { once: true });

  /* ---------- partial save (abandoned leads) ---------- */

  var partialTimer = null;

  function getSnapshot() {
    var naam = splitNaam();
    var snap = {
      lead_id: state.partialLeadId,
      doelgroep: 'Voor mijn bedrijf',
      neon_type: state.neonType,
      neon_tekst: val('neon-b2b-tekst'),
      bedrijfsnaam: val('neon-b2b-bedrijf'),
      voornaam: naam.voornaam,
      achternaam: naam.achternaam,
      email: val('neon-b2b-email'),
      telefoon: val('neon-b2b-tel'),
      bron: BRON
    };
    if (state.uploadedFileUrl) snap.file_url = state.uploadedFileUrl;
    if (state.selectedFile) snap.file_name = state.selectedFile.name;
    if (state.logoLater) snap.logo_later = 'Ja';

    var attribution = getAttribution();
    ATTRIBUTION_KEYS.forEach(function (k) {
      if (attribution[k]) snap[k] = attribution[k];
    });
    return snap;
  }

  function sendPartial(useBeacon) {
    if (state.submitted) return;
    var snap = getSnapshot();
    var hasMin = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(snap.email) || snap.telefoon.length > 0;
    if (!hasMin) return;
    var body = JSON.stringify(snap);
    if (useBeacon && navigator.sendBeacon) {
      navigator.sendBeacon(PARTIAL_API, new Blob([body], { type: 'application/json' }));
      return;
    }
    fetch(PARTIAL_API, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: body })
      .then(function (res) { return res.json(); })
      .then(function (data) {
        if (data.lead_id) {
          state.partialLeadId = data.lead_id;
          sessionStorage.setItem(STORAGE_KEY, state.partialLeadId);
        }
      })
      .catch(function () {});
  }

  function debouncedPartial() {
    clearTimeout(partialTimer);
    partialTimer = setTimeout(function () { sendPartial(false); }, 1500);
  }

  formRoot.querySelectorAll('input, select').forEach(function (field) {
    field.addEventListener('input', debouncedPartial);
    field.addEventListener('change', debouncedPartial);
  });

  window.addEventListener('beforeunload', function () { sendPartial(true); });

  /* ---------- stap 1: keuze + upload/tekst ---------- */

  var uploadWrap = document.getElementById('neon-b2b-upload');
  var tekstWrap = document.getElementById('neon-b2b-tekstin');

  formRoot.querySelectorAll('.neon-b2b-form__choice button').forEach(function (b) {
    b.addEventListener('click', function () {
      formRoot.querySelectorAll('.neon-b2b-form__choice button').forEach(function (x) { x.classList.remove('sel'); });
      b.classList.add('sel');
      state.neonType = b.dataset.type === 'logo' ? 'Logo' : 'Tekst';
      if (state.neonType === 'Tekst') {
        // Wissel naar tekst: eerder gekozen logo vervalt
        state.selectedFile = null;
        state.uploadedFileUrl = '';
        state.logoLater = false;
        if (fileInput) fileInput.value = '';
        if (fileInfo) { fileInfo.hidden = true; fileInfo.textContent = ''; }
        if (uploadNext) uploadNext.hidden = true;
      }
      if (uploadWrap) uploadWrap.hidden = state.neonType !== 'Logo';
      if (tekstWrap) tekstWrap.hidden = state.neonType !== 'Tekst';
      debouncedPartial();
    });
  });

  var drop = document.getElementById('neon-b2b-drop');
  var fileInput = document.getElementById('neon-b2b-file');
  var fileInfo = document.getElementById('neon-b2b-file-info');
  var uploadNext = document.getElementById('neon-b2b-upload-next');

  if (uploadNext) uploadNext.addEventListener('click', function () { go(2); });

  function handleFile(file) {
    if (!ALLOWED_EXT.test(file.name)) {
      showError('neon-b2b-error-file', 'Dit bestandstype is niet toegestaan. Gebruik JPG, PNG, PDF, AI, SVG of EPS.');
      return;
    }
    if (file.size > MAX_FILE_SIZE) {
      showError('neon-b2b-error-file', 'Bestand is te groot (max 50 MB).');
      return;
    }
    hideErrors();
    state.selectedFile = file;
    state.uploadedFileUrl = '';
    state.logoLater = false;
    if (fileInfo) {
      fileInfo.hidden = false;
      fileInfo.textContent = file.name;
    }
    // Terugkeren naar stap 1 met een geupload bestand: toon een verder-knop
    if (uploadNext) uploadNext.hidden = false;

    // Direct uploaden naar Supabase via signed URL, ondertussen door naar stap 2.
    // De promise wordt bewaard zodat de submit erop kan wachten in plaats van
    // het bestand een tweede keer mee te sturen.
    var tUpload = Date.now();
    state.uploadFailed = false;
    state.uploadPromise = fetch(UPLOAD_URL_API, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ filename: file.name, contentType: file.type })
    })
      .then(function (res) {
        if (!res.ok) throw new Error('Failed to get upload URL');
        return res.json();
      })
      .then(function (data) {
        return fetch(data.signedUrl, {
          method: 'PUT',
          headers: { 'Content-Type': file.type },
          body: file
        }).then(function (uploadRes) {
          if (!uploadRes.ok) throw new Error('Upload mislukt');
          state.uploadedFileUrl = data.publicUrl;
          console.info('[bf] logo geupload in ' + (Date.now() - tUpload) + ' ms');
          sendPartial(false);
        });
      })
      .catch(function (err) {
        console.error('Upload error:', err);
        state.uploadFailed = true;
      });

    go(2);
  }

  if (drop && fileInput) {
    drop.addEventListener('click', function () { fileInput.click(); });
    fileInput.addEventListener('change', function () {
      if (fileInput.files.length) handleFile(fileInput.files[0]);
    });
    ['dragover', 'dragenter'].forEach(function (e) {
      drop.addEventListener(e, function (ev) { ev.preventDefault(); drop.classList.add('hot'); });
    });
    ['dragleave', 'drop'].forEach(function (e) {
      drop.addEventListener(e, function (ev) { ev.preventDefault(); drop.classList.remove('hot'); });
    });
    drop.addEventListener('drop', function (ev) {
      if (ev.dataTransfer.files.length) handleFile(ev.dataTransfer.files[0]);
    });
  }

  var skipUpload = document.getElementById('neon-b2b-skip-upload');
  if (skipUpload) {
    skipUpload.addEventListener('click', function () {
      state.logoLater = true;
      go(2);
    });
  }

  var skipTekst = document.getElementById('neon-b2b-skip-tekst');
  if (skipTekst) {
    skipTekst.addEventListener('click', function () {
      state.tekstOnbekend = true;
      go(2);
    });
  }

  var tekstNext = document.getElementById('neon-b2b-tekst-next');
  if (tekstNext) tekstNext.addEventListener('click', function () { go(2); });

  var tekstInput = document.getElementById('neon-b2b-tekst');
  if (tekstInput) {
    tekstInput.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') { e.preventDefault(); go(2); }
    });
  }

  /* ---------- afmeting: eigen maat invullen ---------- */

  var maatSelect = document.getElementById('neon-b2b-maat');
  var maatEigen = document.getElementById('neon-b2b-maat-eigen');
  var maatCm = document.getElementById('neon-b2b-maat-cm');

  // Kiest de klant 'Zelf invullen', dan verschijnt een cm-veld
  function updateMaatVeld() {
    if (!maatSelect || !maatEigen) return;
    var eigen = maatSelect.value === 'Zelf invullen';
    maatEigen.hidden = !eigen;
    if (!eigen && maatCm) maatCm.value = '';
  }

  if (maatSelect) {
    maatSelect.addEventListener('change', function () {
      updateMaatVeld();
      if (maatSelect.value === 'Zelf invullen' && maatCm) maatCm.focus();
    });
    updateMaatVeld();
  }

  // Levert de waarde zoals de API hem verwacht: '120cm' i.p.v. 'Zelf invullen'
  function getAfmeting() {
    var keuze = val('neon-b2b-maat') || 'Weet ik nog niet';
    if (keuze !== 'Zelf invullen') return keuze;
    var cm = val('neon-b2b-maat-cm');
    return cm ? cm + 'cm' : '';
  }

  formRoot.querySelectorAll('[data-back]').forEach(function (b) {
    b.addEventListener('click', function () { go(parseInt(b.dataset.back, 10)); });
  });

  /* ---------- stap 2: contact → lead versturen ---------- */

  var leadBtn = document.getElementById('neon-b2b-lead-btn');

  function validateStep2() {
    hideErrors();
    var ok = true;
    if (!state.neonType) {
      // Terugvallen op stap 1 als er nog geen keuze is (bijv. via sticky CTA)
      go(1);
      showError('neon-b2b-error-type', 'Kies eerst wat je in neon wilt.');
      return false;
    }
    if (!val('neon-b2b-bedrijf')) {
      showError('neon-b2b-error-bedrijf', 'Vul je bedrijfs- of organisatienaam in.');
      ok = false;
    }
    var naam = splitNaam();
    if (!naam.voornaam) {
      showError('neon-b2b-error-naam', 'Vul je naam in.');
      ok = false;
    }
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(val('neon-b2b-email'))) {
      showError('neon-b2b-error-email', 'Vul een geldig e-mailadres in.');
      ok = false;
    }
    if (!val('neon-b2b-tel')) {
      showError('neon-b2b-error-tel', 'Vul je telefoonnummer in.');
      ok = false;
    }
    if (val('neon-b2b-maat') === 'Zelf invullen' && !val('neon-b2b-maat-cm')) {
      showError('neon-b2b-error-maat', 'Vul je gewenste breedte in cm in.');
      ok = false;
    }
    return ok;
  }

  if (leadBtn) {
    leadBtn.addEventListener('click', function () {
      if (!validateStep2()) return;

      // De API doet er soms enkele seconden over; laat zien dat er iets gebeurt
      // in plaats van een knop die stil blijft staan.
      var leadBtnLabel = leadBtn.querySelector('.neon-b2b__btn-label');
      var leadBtnText = leadBtnLabel ? leadBtnLabel.textContent : '';
      if (leadBtnLabel) leadBtnLabel.textContent = 'Bezig met verzenden…';
      leadBtn.classList.add('is-loading');
      leadBtn.disabled = true;

      var tSubmit = Date.now();

      // Wacht op de logo-upload die tijdens stap 2 al liep. Zonder dit wordt
      // het bestand een tweede keer meegestuurd in de submit zelf, wat de
      // verzending onnodig lang maakt.
      (state.uploadPromise || Promise.resolve()).then(function () {
        var waited = Date.now() - tSubmit;
        if (waited > 200) console.info('[bf] gewacht op logo-upload: ' + waited + ' ms');
        var naam = splitNaam();
        var formData = new FormData();

        if (state.neonType === 'Logo' && state.uploadedFileUrl) {
          formData.append('file_url', state.uploadedFileUrl);
        } else if (state.neonType === 'Logo' && state.selectedFile && state.uploadFailed) {
          // Alleen als de upload naar de opslag is mislukt: stuur het bestand
          // zelf mee. Anders volstaat de URL en blijft de submit klein.
          formData.append('bestand', state.selectedFile);
        }
        if (state.neonType === 'Logo' && state.logoLater) formData.append('logo_later', 'Ja');

        formData.append('doelgroep', 'Voor mijn bedrijf');
        formData.append('neon_type', state.neonType);
        if (state.neonType === 'Tekst') formData.append('neon_tekst', val('neon-b2b-tekst'));
        formData.append('afmeting', getAfmeting());
        formData.append('locatie', '');
        formData.append('timing', val('neon-b2b-wanneer') || 'Nog flexibel');
        formData.append('voornaam', naam.voornaam);
        formData.append('achternaam', naam.achternaam);
        formData.append('email', val('neon-b2b-email'));
        formData.append('telefoon', val('neon-b2b-tel'));
        formData.append('bedrijfsnaam', val('neon-b2b-bedrijf'));
        formData.append('wensen', '');
        formData.append('bron', BRON);
        if (state.partialLeadId) formData.append('partial_lead_id', state.partialLeadId);

        var attribution = getAttribution();
        ATTRIBUTION_KEYS.forEach(function (k) {
          if (attribution[k]) formData.append(k, attribution[k]);
        });

        var tApi = Date.now();
        return fetch(SUBMIT_API, { method: 'POST', body: formData })
          .then(function (response) {
            // Lege of niet-JSON body mag een geslaagde submit (2xx) niet blokkeren;
            // alleen echte serverfouten leiden tot de foutmelding.
            console.info('[bf] API-response na ' + (Date.now() - tApi) + ' ms');
            return response.text().then(function (raw) {
              var data = {};
              try { data = JSON.parse(raw); } catch (e) {}
              if (!response.ok) {
                console.error('Submit response:', response.status, raw);
                throw new Error('Server error: ' + response.status);
              }
              return data;
            });
          })
          .then(function (data) {
            state.submitted = true;
            sessionStorage.removeItem(STORAGE_KEY);

            // Conversie-events vuren op de bedankpagina (betrouwbaarder dan vlak
            // voor een redirect). Het meta_lead_event_id zorgt daar voor dedup
            // tussen browser-pixel en server-side CAPI.
            try {
              sessionStorage.setItem('bf_lead_conversion', JSON.stringify({
                event_id: (data && data.meta_lead_event_id) || '',
                ts: Date.now()
              }));
            } catch (e) {}

            window.location.href = THANKYOU_URL;
          })
          .catch(function (err) {
            console.error('Submit error:', err);
            showError('neon-b2b-error-submit', 'Er ging iets mis bij het verzenden. Probeer het opnieuw of app ons.');
          })
          .finally(function () {
            if (leadBtnLabel) leadBtnLabel.textContent = leadBtnText;
            leadBtn.classList.remove('is-loading');
            leadBtn.disabled = false;
          });
      });
    });
  }

  /* ==========================================================================
     REVEAL ON SCROLL
     ========================================================================== */

  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); }
      });
    }, { threshold: 0.12 });
    document.querySelectorAll('.neon-b2b-rv').forEach(function (el) { io.observe(el); });
  }

})();
